import React, { useState } from 'react'

function AccessCodeLabel({ code }: { code: string }) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <div>
      <span>{isVisible && code !== '****' ? code : '****'}</span>
      <button
        type="button"
        disabled={code === '****'}
        onClick={() => setIsVisible(!isVisible)}
        style={{
          background: 'none',
          border: 'none',
          cursor: code === '****' ? 'not-allowed' : 'pointer',
          fontSize: '20px',
          padding: '0',
        }}
      >
        {isVisible ? <i className="fal fa-md fa-eye-slash ms-2" /> : <i className="fal fa-md fa-eye ms-2" />}
      </button>
    </div>
  )
}

export default AccessCodeLabel
